import { getQualifiedParticipantsFilter } from '../../../../backend/features/mission/shared';
import { mapDeploymentDurationIdToDurationLength } from '../../../../backend/features/shift/shared/utils';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { deploymentDurationEntityName } from '@juvare/credentialing/backend/config/shared';
import { isTrainFeatureEnabled } from '@juvare/credentialing/ui/utils';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
export const useShiftPositionAccountFilter = ({ missionOrganizationSharing, missionGroupSharing, shiftPosition, }) => {
    const { data: deploymentDurations } = useStorageList(deploymentDurationEntityName, {});
    const userState = useUserState();
    const filter = [];
    if (shiftPosition) {
        const deploymentDurationsMap = deploymentDurations ? mapDeploymentDurationIdToDurationLength(deploymentDurations.rows) : {};
        filter.push(...getQualifiedParticipantsFilter({
            isTrainFeatureEnabled: isTrainFeatureEnabled(userState),
            missionOrganizationSharing,
            missionGroupSharing,
            position: shiftPosition,
            deploymentDurations: deploymentDurationsMap,
        }));
    }
    return filter;
};
